import { QUERY_KEYS } from '../../../../consts';
import { getDocumentInfoService } from '../../../../services';
import { getAtomWithMutation } from '../../../../utils';

export const getDocumentInfoAtom = getAtomWithMutation({
  mutationKey: QUERY_KEYS.DOCUMENTS.DOCUMENT_INFO,
  mutationFn: () => getDocumentInfoService,
});
